
import { notificationFunctions, Urgency } from "@/types"
import { Component, Prop, Vue } from "vue-property-decorator"

@Component({})
export default class NotificationsButton extends Vue {
	@Prop({ type: Number, required: true })
	numberOfNotifications!: number;

	@Prop({ type: Number, required: false, default: null })
	highestUrgency!: Urgency;

	private get notificationNumber () {
		if (this.numberOfNotifications >= 10) {
			return "9+"
		}
		return this.numberOfNotifications.toString()
	}

	private get hasNotifications () {
		return this.numberOfNotifications > 0
	}

	private get notificationBadgeClass () {
		let classText = ""

		classText = this.hasNotifications ? "has-notifications " : ""
		classText += this.highestUrgency != null
			? (notificationFunctions.urgencyToString(this.highestUrgency)!.toLowerCase() + "-badge")
			: "badge-secondary"

		return classText
	}
}
